export default __webpack_public_path__ + "static/media/attraction-time.35ef6bca.svg";